module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-footer-wrap"
  }, [_c('div', {
    staticClass: "text-outer"
  }, [_c('span', {
    staticClass: "corp-right"
  }, [_vm._v("Directed By NatureDesign")]), _vm._v(" "), _c('span', {
    staticClass: "text-wrap"
  }, [_c('span', [_vm._v(_vm._s(_vm.text || '鹰眼监控感知大屏欢迎您！'))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d4729518!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/page-footer/index.vue
// module id = 244
// module chunks = 0